import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private api: ApiService) {}

  getDropDownItems(module: string, keyboard: string = '', isGrid = false, exclude = false) {
    return this.api.get(
      `/search-data?office_id=${this.api.getOfficeId()}&user_id=${module === 'teams' ? '' : this.api.getUserId()}&Keywords=${keyboard}&page=1&per_page=999999&limit=999999&module=${module}&grid_view=${isGrid}&exclude_solds=${exclude}`
    );
  }

  /** `officeId` overrides the active office — e.g. a report widget scoping to the report's own office. */
  getDropDownItemsCache(module: string, keyboard: string = '', isGrid = false, exclude = false, officeId: string | null = null) {
    return this.api.getApi(
      `/search-data?office_id=${officeId || this.api.getOfficeId()}&user_id=${module === 'teams' ? '' : this.api.getUserId()}&Keywords=${keyboard}&page=1&per_page=999999&limit=999999&module=${module}&grid_view=${isGrid}&exclude_solds=${exclude}`
    );
  }

  getModuleAgent(modelName: string = '') {
    return this.api.get(`/users/module-agent-users?module_name=${modelName}&office_id=${this.api.getOfficeId()}`);
  }

  getJobTypes() {
    return this.api.get(`/job-types?office_id=${this.api.getOfficeId()}`);
  }

  getUserStaff(office_count: boolean = true) {
    return this.api.get(`/roles/user-summary/${this.api.getOfficeId()}?office_count=${office_count}&show=staff`);
  }

  getPriorities() {
    return this.api.get(`/priorities?office_id=${this.api.getOfficeId()}`);
  }

  getTaskStatus() {
    return this.api.get(`/task-statuses?office_id=${this.api.getOfficeId()}`);
  }

  getProjects() {
    return this.api.get(`/byd-project?office_id=${this.api.getOfficeId()}&is_short=${true}&is_parser=${true}`);
  }

  searchSuburb = (query: any) => {
    return this.api.get('/suburbs/get?suburb=' + query);
  };
  getSuburbList = () => {
    return this.api.get(`/listing/all-suburbs?office_id=${this.api.getOfficeId()}`);
  };
  getPropertyListingFeature = () => {
    return this.api.get(
      `/eng/misc/entity/getallbyname?entityname=property_feature&userid=${this.api.getUserId()}&officeid=${this.api.getOfficeId()}`
    );
  };

  getWorkFlowProcess = (id: any) => {
    return this.api.get(
      `/workflow-process?office_id=${this.api.getOfficeId()}&module=${'contacts'}&record_id=${id}&page=${1}&per_page=${10}&workflow_type=${'progress'}`
    );
  };

  getEmailTemplate() {
    return this.api.get(`/settings/email-template?office_id=${this.api.getOfficeId()}`);
  }
  getPhraseSuggestionByAi = (payload: any) => {
    return this.api.post(`/ai/gpt/suggest/heading`, payload);
  };
  getStreamSuggestionByAi(payload: any) {
    const headers = new HttpHeaders();
    return this.api.postpoll(`/ai/gpt/suggest/description/stream`, payload, { headers, responseType: 'text' });
  }
  getOfficeDomainEmail() {
    return this.api.get(`/settings/default-domain-portal-email/${this.api.getOfficeId()}`);
  }
  saveOfficeDomainEmail(payload: any) {
    return this.api.post(`/settings/default-domain-portal-email`, { ...payload, office_id: this.api.getOfficeId() });
  }
  getUserSplitterStateByModuleName(moduleName: string) {
    return this.api.get(`/views/splitter/${this.api.getUserId()}?office_id=${this.api.getOfficeId()}&type=${moduleName}`);
  }
  saveUserSplitterState(payload: any) {
    return this.api.post('/views/splitter', payload);
  }

  getDeactiveStaffList() {
    return this.api.get(
      `/users/office-staff-list?officeid=${this.api.getOfficeId()}&uid=${this.api.getUserId()}&page=${1}&per_page=${99999}&role=${''}&include=groups,offices&show=staff&search=&group=&deactive=${true}`
    );
  }

  saveDisplayFullPage(payload: any) {
    return this.api.post('/users/fullscreen-preference', payload);
  }

  getDisplayFullPage(module: string = '') {
    return this.api.get(`/users/fullscreen-preference/${this.api.getUserId()}?module=${module}`);
  }

  saveLeadSummaryPreference(payload: any) {
    return this.api.post('/users/lead-summary-preference', payload);
  }

  getLeadSummaryPreference() {
    return this.api.get(`/users/lead-summary-preference/${this.api.getUserId()}`);
  }

  getModuleAccess(module: string = '') {
    return this.api.get(`/users/module-access-received/${this.api.getUserId()}?module=${module}`);
  }

  saveModuleViewPreference(payload: any) {
    return this.api.post('/users/module-view-preference', payload);
  }

  getModuleViewPreference(module: string = '') {
    return this.api.get(`/users/module-view-preference/${this.api.getUserId()}?module=${module}`);
  }
}
